import { Ids } from '../common/ids.model';

export class UpdateTemplate {
  parentTemplateId: number;
  brandId: number;
  categoryId: number;
  modelIds: Ids[];
  colorIds: Ids[];
  shotTypes: TemplateShotTypeDTI[];

  constructor(init?: Partial<UpdateTemplate>) {
    Object.assign(this, init);
  }
}

export class TemplateShotTypeDTI {
  public shotTypeId: number;
  public shotTypeName: string;
  public shotTypeCode: string;
  public sizeGroupId: number;
  public ord: number;
  public aspectRatioId: number;
  public mediaFormatId: number
  public codifiedUsedId: number;

  constructor(init?: Partial<TemplateShotTypeDTI>) {
    Object.assign(this, init);
  }
}
